export default class Sounds
{
    constructor(_resources)
    {
        this.resources = _resources
        this.lastPlayed = {}
    }

    play(_name, _volume = 0.25, _throttle = 100)
    {
        const now = performance.now()
        if(now - (this.lastPlayed[_name] ?? 0) < _throttle)
            return
        this.lastPlayed[_name] = now
        const source = this.resources.items[_name]
        if(!source)
            return
        const audio = source.cloneNode()
        audio.volume = _volume
        audio.play().catch(() => {})
    }
}
